import styled, { css } from 'styled-components';
import { InputBox } from '@/components/UI/Input/Input.styles';

export const DigitInput = styled(InputBox).attrs({
  inputMode: 'numeric',
  autoComplete: 'off',
  maxLength: 1,
})<{ $isFocused: boolean; $isHoverSuppressed: boolean }>`
  height: 50px;
  padding: 0;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  font-size: 22px;
  font-weight: 500;
  text-align: center;

  &::placeholder {
    color: ${({ theme }) => theme.palette.secondary.border};
    font-size: 22px;
  }

  ${({ $isHoverSuppressed, theme }) =>
    !$isHoverSuppressed &&
    css`
      @media (hover: hover) {
        &:hover {
          border-color: ${theme.palette.system.blue};
        }
      }
    `}

  ${({ $isFocused, theme }) =>
    $isFocused &&
    css`
      border-color: ${theme.palette.system.blue};
    `}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 48px;
    border-radius: 12px;
    font-size: 18px;

    &::placeholder {
      font-size: 20px;
    }
  }
`;

export const SubRow = styled.div<{ $isSmall?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  width: 30%;

  ${({ $isSmall }) =>
    $isSmall &&
    css`
      width: 20%;
    `}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 2px;
    width: 32%;

    ${({ $isSmall }) =>
      $isSmall &&
      css`
        width: 22%;
      `}
  }
`;
